import { createMilestoneError, ProjectElementType } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ list, milestone, project, range }) =>
    present(
      repository
        .saveMilestone(list, milestone)
        .then((savedMilestone) =>
          (range
            ? repository.moveProjectElement(
                savedMilestone.uuid,
                ProjectElementType.MILESTONE,
                list,
                range,
                false,
              )
            : Promise.resolve()
          ).then(() => ({
            list,
            milestone: savedMilestone,
            project,
            range,
          })),
        )
        .catch((error) =>
          Promise.reject({
            error: { ...createMilestoneError, ...error },
            list,
            milestone,
            project,
            range,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
